import useFetch from '@/api/useFetch';
import HostDetails from '@/types/hostDetails';
import { WidgetConfig } from '@/types/widgetConfig';
import { QueryClient, useQuery } from '@tanstack/react-query';

export const HostConfigurationQueryKey = ['hostConfiguration'];

const useWidgetHostConfiguration = (
  queryClient: QueryClient,
  widgetConfig: WidgetConfig | undefined
) => {
  const apiCall = useFetch();

  const queryOptions = {
    queryKey: HostConfigurationQueryKey,
    enabled: !!widgetConfig,
    queryFn: async () => {
      const response = await apiCall('/host', 'GET');

      return await response.json();
    }
  };
  const { data, isFetching, error } = useQuery<{ hostDetails: HostDetails[] }>(
    queryOptions,
    queryClient
  );

  return { hostDetails: data?.hostDetails, isFetching, error };
};

export default useWidgetHostConfiguration;
